import Modal from "components/blocks/Modal";
import useMutation from "hooks/useMutation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OrdersService } from "services/orders";
import { useNotification } from "../../../../../../../../../hooks/useNotification";

const RequestAnQueryModal = ({
  isOpen,
  onClose,
  onConfirm,
  orderId,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  orderId: number;
}) => {
  const { t } = useTranslation(["Orders", "Common"]);
  const { showNotification } = useNotification();
  const [notes, setNotes] = useState("");
  const { loading: isSubmitting, mutateAsync } = useMutation({
    queryFn: async (notes: string) => {
      return await OrdersService.startProgramOrderQueryRequest(orderId, {
        notes,
        actionName: "",
        serialGuid: "af72e3ce-1bbf-41e9-900b-04bb6628fff4", // TODO: fake serialGuid to be removed
      });
    },
  });

  const onCancel = () => {
    onClose?.();
    setNotes("");
  };

  const onSubmit = async (notes: string) => {
    const res = await mutateAsync(notes);

    if (res && !res.hasError) {
      onConfirm();
      showNotification({ description: t("Common:success"), type: "success" });
      setNotes("");
    }
  };

  return (
    <Modal
      containerClassName="bg-white pb-2"
      isOpen={isOpen}
      onClose={onClose}
      title={t("queryRequest")}
      withHeaderBorder
      size="lg"
      titleClassName="fs-6 text-dark"
      bodyMargin="py-3"
    >
      <label className="form-label mt-2">{t("Common:notes")}</label>
      <textarea
        className={`form-control`}
        rows={5}
        placeholder={t("Common:notes")}
        onChange={(e) => setNotes(e.target.value)}
        value={notes}
        style={{ resize: "none" }}
      />

      <div className="divider mt-3"></div>

      <div className="d-flex justify-content-center gap-2 w-100">
        <button type="button" className="btn text-dark rounded-3 p-10-32P" onClick={onCancel}>
          {t("Common:cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary rounded-3 p-10-32P"
          disabled={!notes.length || isSubmitting}
          onClick={async () => {
            if (!notes.length) return;

            await onSubmit(notes);
          }}
        >
          {!isSubmitting ? t("send") : <div className="custom-loader"></div>}
        </button>
      </div>
    </Modal>
  );
};

export default RequestAnQueryModal;
